const CAP64 = {
  id: 64,
  slug: "cap64-carta-final-del-profesor",
  title: "Capítulo 64 — Carta final del profesor",
  module: 6,
  sections: [
    {
      heading: "Resumen del capítulo",
      text: [
        "En este capítulo se desarrolla el tema: Carta final del profesor."
      ]
    }
  ]
};

export default CAP64;
